import Vue from "vue"
import PerfectScrollbar from "perfect-scrollbar"
import "perfect-scrollbar/css/perfect-scrollbar.css"
import { debounce, isBoolean, isString, isArray } from "lodash"

/**
 * @description 为自定义滚动条全局注入自定义指令。自动判断该更新PerfectScrollbar还是创建它
 * @param {Element} el - 必填。dom元素
 */
function mountScrollBar(el, rootEl) {
  if (rootEl._ps_ instanceof PerfectScrollbar) {
    el._ps_debounced_update()
  } else {
    el.style.overflow = "hidden"
    rootEl._ps_ = el._ps_ = new PerfectScrollbar(el, { minScrollbarLength: 20 })
    el._ps_debounced_update = debounce(() => el._ps_.update(), 200)
  }
}

function executeDirective(el, rootEl) {
  if (!el) return console.debug(`未找到对应的dom`)

  const rules = ["static", "fixed", "absolute", "relative"]
  let position = window.getComputedStyle(el, null).position
  if (!rules.includes(position)) {
    console.error(
      `perfect-scrollbar所在的容器的position属性必须是以下之一：${rules.join("、")}`,
      el,
      position
    )
  }
  if (position === "static") {
    el.style.position = "relative" // 尽量在设置v-ps的时候指定position,在此处修改会导致浏览器重新渲染
  }
  mountScrollBar(el, rootEl)
}

function handleDirective(el, value) {
  if (value === undefined) return executeDirective(el, el)
  if (isBoolean(value)) {
    if (!value) return
    return executeDirective(el, el)
  }
  if (isString(value)) {
    return executeDirective(el.querySelector(value), el)
  }
  if (isArray(value)) {
    for (let item of value) {
      executeDirective(el.querySelector(item), el)
    }
  }
}

Vue.directive("ps", {
  inserted(el, { value }) {
    handleDirective(el, value)
  },
  componentUpdated(el, { value }, vnode) {
    vnode.context.$nextTick(() => {
      handleDirective(el, value)
    })
  },
  unbind(el) {
    el._ps_?.destroy()
  }
})
